export enum ConfigureWorkflowType {
  'Default' = 'Default',
  'Branded' = 'Branded',
  'CustomizedProofreading' = 'CustomizedProofreading',
  'CustomizedEditing' = 'CustomizedEditing'
}
